import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemPeanuts extends Item {
    constructor() {
        super(definitions.ITEM_ID.PEANUTS, texture("prop_peanuts_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(0, 0));
    }
}